import './cocktails4u/style';
import FormStructure from './cocktails4u/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js